var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{ref:"el",staticClass:"omapi-link-arrow-before omapi-wizard-back",attrs:{"href":"#","disabled":_vm.disabled},on:{"click":function($event){$event.preventDefault();return _vm.$bus.$emit('onboardingPrevPage')}}},[_vm._v("\n\tGo Back\n")])}
var staticRenderFns = []

export { render, staticRenderFns }